import { setI18nLanguage } from "@/setup/i18n-setup";
import { initRapsoteUserLanguage } from "@/api/rapsotecClient";
import { defineStore } from "pinia";

export const useLanguageStore = defineStore("languageStore", {
  state: () => ({
    lang: "fr",
  }),
  actions: {
    setLanguage(payload) {
      initRapsoteUserLanguage(payload);
      setI18nLanguage(payload);
      this.lang = payload;
    },
  },
});
